const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-spinner ---
let __fez_component_0;
{

__fez_component_0 = class {
  NAME = 'span'

  PROPS = {
    size: { type: String, default: 'md', enum: ['sm', 'md', 'lg'] },
    label: { type: String, default: 'Loading' },
  }

  CSS = `:fez {
display:inline-flex;color:var(--color-accent);.ring{display:block;border:2px solid var(--color-border);border-top-color:currentColor;border-radius:var(--radius-full);animation:ui-spinner-spin 0.75s linear infinite}.sm{width:16px;height:16px}.md{width:24px;height:24px;border-width:3px}.lg{width:36px;height:36px;border-width:3px}@keyframes ui-spinner-spin{to{transform:rotate(360deg)}}
}`

  HTML = `<span class="ring {props.size}" role="status"><span class="sr-only">{props.label}</span></span>`
};
}

Fez('ui-spinner', __fez_component_0);

export default __fez_component_0;
